export default __webpack_public_path__ + "static/media/Group959.2fc2a39a.svg";